import type { DataRouter } from "react-router-dom";

import { i18n } from "@lingui/core";
import { I18nProvider } from "@lingui/react";
import { QueryClientProvider } from "@tanstack/react-query";
import { RouterProvider } from "react-router-dom";

import { queryClient } from "../api/query-client";
import { TooltipProvider } from "../components/ui-kit/base/tooltip";
import { DialogProvider } from "../components/ui-kit/dialog-provider";
import { ToastsProvider } from "../components/ui-kit/toasts";

/** The whole app: providers, layout root and routes. The caller supplies the router. */
export function App({ router }: { router: DataRouter }) {
  return (
    <div className="flex min-h-screen flex-col">
      <I18nProvider i18n={i18n}>
        <QueryClientProvider client={queryClient}>
          <TooltipProvider>
            <ToastsProvider>
              <DialogProvider>
                <RouterProvider router={router} />
              </DialogProvider>
            </ToastsProvider>
          </TooltipProvider>
        </QueryClientProvider>
      </I18nProvider>
    </div>
  );
}
